import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import DeleteButton from '../../shared/DeleteButton.js';
import Calves from '../../herd/Calves.js';
import { BullTagCell } from './ListBulls.js';
import '../../shared/DefaultBadge.css';
import './BullCardList.css';

const BullCard = ({ row, onDeleted, onSaved, defaultBullId, onSetDefault }) => {
  const { t } = useTranslation();
  const [expanded, setExpanded] = useState(false);
  const aliases = Array.isArray(row.matches) ? row.matches.join(', ') : row.matches || '';
  const isDefault = row._id === defaultBullId;

  return (
    <div className={`bull-card ${expanded ? 'expanded' : ''}`} onClick={() => setExpanded(e => !e)}>
      <div className="bull-card-main">
        <div className="bull-card-name">{row.name || '—'}</div>
        {isDefault && <span className="default-badge">★ {t('default')}</span>}
        <div className="bull-card-chevron">{expanded ? '▲' : '▼'}</div>
        {aliases && <div className="bull-card-aliases">{aliases}</div>}
      </div>

      {expanded && (
        <div className="bull-card-detail" onClick={e => e.stopPropagation()}>
          <div className="bull-card-detail-row">
            <span>{t('bull_breed')}</span><span className="bull-breed-value">{row.breed || '—'}</span>
          </div>
          <div className="bull-card-detail-row">
            <span>{t('bull_tag')}</span>
            <BullTagCell bull={row} onSaved={onSaved} />
          </div>
          <div className="bull-card-detail-row">
            <span>{t('aliases')}</span><span>{aliases || '—'}</span>
          </div>
          <div className="bull-card-detail-row">
            <span>{t('created_by')}</span><span>{row.created_by || '—'}</span>
          </div>
          {row.tag
            ? <Calves tag={row.tag} field="father" />
            : <div className="bull-card-tag-hint">{t('bull_tag_hint_list')}</div>}
          <div className="bull-card-actions">
            {!isDefault && (
              <button className="set-default-btn" onClick={() => onSetDefault(row)}>{t('set_as_default')}</button>
            )}
            <DeleteButton
              collection="reproduction.bulls"
              data={[row]}
              onComplete={onDeleted}
              onError={() => {}}
            />
          </div>
        </div>
      )}
    </div>
  );
};

const BullCardList = ({ data, onRefresh, defaultBullId, onSetDefault }) => {
  return (
    <div className="bull-card-list">
      {data && data.map(row => (
        <BullCard key={row._id} row={row} onDeleted={onRefresh} onSaved={onRefresh} defaultBullId={defaultBullId} onSetDefault={onSetDefault} />
      ))}
      {(!data || data.length === 0) && (
        <div className="bull-card-empty">—</div>
      )}
    </div>
  );
};

export default BullCardList;
